import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { DatePipe } from '@angular/common';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Http } from '@angular/http';

@Component({
  selector: 'app-attachment',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.css']
})
export class AttachmentComponent implements OnInit {

  @Input() formname: string = "";
  @Input() trxid: number = 0;
  @Input() formmode: string = "";

  @Output() filterChanged = new EventEmitter<number>();
  @Output() attachmentChanged = new EventEmitter<string>();

  @Output() attachmentcountChanged = new EventEmitter<number>();

  @Output() emitData = new EventEmitter();

  attachmentColl: any = [];
  attachBO: any = {}


  //set image
  image;
  strImage: any;
  pdfSrc = "";



  constructor(private toastr: ToastrService, private appService: AppdataService, private datePipe: DatePipe,
    private loginService: LoginserviceService, private confirmationDialogService: ConfirmationDialogService,
    private activeModal: NgbActiveModal, private http: Http) { }

  ngOnInit() {
    this.fnGetAttachment();
  }



  fnOpenFileBrowser(event: any) {

    event.preventDefault();

    let element: HTMLElement = document.getElementById('image') as HTMLElement;
    element.click();

  }

  fnUploadImages(event) {
    try {

      if (event.target.files && event.target.files[0]) {
        var filesAmount = event.target.files.length;

        for (let i = 0; i < filesAmount; i++) {

          var file: File = event.target.files[i];


          // if(file.size/1000 >this.imagesize){ 
          //   continue;
          // }

          const fileReader: FileReader = new FileReader();

          fileReader.onload = (event) => {


            this.image = fileReader.result;
            this.strImage = this.image.split(',')[1];


            var filetype = file.name.split(".").pop();
            var filename = file.name;
            var filesize = file.size;

            var _skuimages =
            {
              attachmentid: 0,
              trxid: this.trxid,
              trxtype: this.formname,
              image: this.image,
              docstrimage: this.strImage,
              doctype: filetype,
              filename: filename,
              filesize: filesize,
              createdby: this.loginService.fnGetModUserId()
            }

            if (this.formmode === 'EDIT') {
              this.fnInsertAttachment(_skuimages);
            }
            else {
              this.attachmentColl.push(_skuimages);

              this.attachmentcountChanged.emit(this.attachmentColl.length)
            }


          }

          fileReader.readAsDataURL(event.target.files[i]);
        }




      }


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }

  }


  removeimage(pictureindex) {


    // if(this.attachmentColl[pictureindex].picid>0){
    //   this.attachmentColl[pictureindex].isclear=1;          
    // }
    // else{
    //   this.attachmentColl.splice(pictureindex, 1); 
    // }

  }




  //Save
  fnGetAttachment() {
    if (this.trxid > 0) {
      var data = {
        'trxid': this.trxid,
        'trxtype': this.formname,
      }


      this.appService.fngetAttachmentDetails(data).subscribe(
        (res) => {
          if (res.json().status === 200) {
            var result = res.json().result;

            this.attachmentColl = result;

            this.attachmentcountChanged.emit(this.attachmentColl.length)
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        });
    }

  }

  public fnSaveAttachmentByAddMode() {
    let i = 0;
    for (let abo of this.attachmentColl) {

      abo.trxid = this.trxid;
      abo.trxtype = this.formname;

      this.appService.fnInsertAttachment(abo).subscribe(
        (res) => {
          if (res.json().status === 200) {
            var result = res.json().result;

            if (this.formmode === 'ADD' && i === this.attachmentColl.length - 1) {
              this.attachmentChanged.emit('DONE')
            }

            i += 1;

          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        });
    }

  }

  fnInsertAttachment(data) {

    this.appService.fnInsertAttachment(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          var result = res.json().result;
          if (this.formmode === 'EDIT') {
            this.fnGetAttachment();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  fnAttachmentViewClick(pBO) {
    this.attachBO = pBO;
    this.pdfSrc = pBO.filepath;


  }

  fnDeleteAttachmentConfirm(id) {
    this.confirmationDialogService.confirm('Confirm..', 'Do you  want to remove Attachment ?')
      .then((confirmed) => {
        if (confirmed) {
          this.fnDeleteAttachment(id);
        }
      }
      );
  }
  fnDeleteAttachment(id) {

    var data = {
      'trxid': id,
      'trxtype': this.formname
    }


    this.appService.fnDeleteAttachmentDetails(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          this.fnGetAttachment()
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }


  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }
}
